import React from 'react';

// Components.
import Logo from 'app/client/components/Logo';

// Styled.
import * as S from './styled';

/**
 * Shown while the app shell boots (the Layout's initial settings fetch, e.g.
 * on a full reload): the centered Exonet logo with a "Portal" label, matching
 * the server boot screen so the handoff is seamless.
 *
 * @returns {Element} The rendered boot loader.
 */
const BootLoader = () => (
  <S.Wrapper>
    <S.Brand>
      <Logo />
      <S.Label>Portal</S.Label>
    </S.Brand>
  </S.Wrapper>
);

export default BootLoader;
